import { SliderItem, SliderItemLabel, SliderItemTitle } from '@bnnvara/slider';
import PropTypes from 'prop-types';
import React from 'react';

import Link from '../../components/Link';
import resizeImageSource from '../../helpers/resizeImageSource';

const ComposableMixedContentSliderCard = ({
  thumbnail,
  title,
  id,
  url,
  urlLabel,
  index,
}) => {
  const imageSrc = thumbnail && thumbnail.url;
  const hasImage = thumbnail && !!imageSrc;

  return (
    <Link
      href={url}
      key={id}
      category="mixedcontentslider"
      action="click"
      label={`slide-${index}`}
    >
      <SliderItem hasImage={hasImage}>
        <img
          src={
            hasImage
              ? resizeImageSource(imageSrc, 500, 1 / 1)
              : 'data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAfQAAAABCAQAAACC95QfAAAAEUlEQVR42mNkGAWjYBQMewAAB9IAAi/SD5wAAAAASUVORK5CYII='
          }
          alt={title}
        />
        <div className="SliderBody">
          <SliderItemTitle hasImage={hasImage}>{title}</SliderItemTitle>
          <SliderItemLabel hasImage={hasImage}>{urlLabel}</SliderItemLabel>
        </div>
      </SliderItem>
    </Link>
  );
};

ComposableMixedContentSliderCard.propTypes = {
  id: PropTypes.string.isRequired,
  urlLabel: PropTypes.string.isRequired,
  title: PropTypes.isRequired,
  url: PropTypes.string.isRequired,
  thumbnail: PropTypes.shape({
    url: PropTypes.string,
  }),
  index: PropTypes.number.isRequired,
};

ComposableMixedContentSliderCard.defaultProps = {
  thumbnail: null,
};

export default ComposableMixedContentSliderCard;
